import { filter, tap } from 'rxjs';
import { TUI_IS_MOBILE_RES, TuiHintModule } from '@taiga-ui/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  DestroyRef,
  HostBinding,
  HostListener,
  inject,
  Input,
} from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';

import { SideNavComponent } from '../side-nav';
import { IconComponent, IconName } from '../../../icon';

@Component({
  selector: 'iss-side-nav-menu-item',
  templateUrl: './side-nav-menu-item.component.html',
  styleUrls: [ './side-nav-menu-item.component.scss' ],
  standalone: true,
  imports: [ NgClass, IconComponent, TuiHintModule, AsyncPipe ],
})
export class SideNavMenuItemComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly sideNav = inject(SideNavComponent);
  public readonly isMobileRes$ = inject(TUI_IS_MOBILE_RES);

  @Input({ required: true }) iconName!: IconName;

  @HostBinding('data-title') @Input({ required: true }) public title!: string;

  @HostListener('click')
  onClick(): void {
    this.isMobileRes$.pipe(
      filter(Boolean),
      tap(() => this.sideNav.toggleExpanded()),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }

  public get expanded(): boolean {
    return Boolean(this.sideNav.expanded);
  }
}
